import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import '../FirstPageDesigns/FirstPage.css';
import searchinterfacesymbol from '../../../Assets/search-interface-symbol.png'
import assignedTask from '../../../Assets/assignedTask.png'
import comingCrane from '../../../Assets/comingCrane.png'
import checksuccess from '../../../Assets/checksuccess.png'
import crossUser from '../../../Assets/crossUser.png'
import historyUser from '../../../Assets/historyUser.png'
import workDoneUser from '../../../Assets/workDoneUser.png'
import reachedUser from '../../../Assets/reachedUser.png'
import filterUser from '../../../Assets/filterUser.png'
import Modal from '../../../Component/CompanyAdmin/Location1/Modal.jsx';
import NoDataFound from '../../../Component/Customers/Cards/NoDataFound.jsx';
import Loading from '../../../Component/Customers/Cards/Loading.jsx';
import icon11 from '../../../Assets/crane/icon11.svg'
import icon12 from '../../../Assets/crane/icon12.svg'
import icon13 from '../../../Assets/crane/icon13.svg'
import icon14 from '../../../Assets/crane/icon14.svg'
import icon15 from '../../../Assets/crane/icon15.svg'
import icon16 from '../../../Assets/crane/icon16.svg'
import search from '../../../Assets/home2/search.svg'
import CraneSideBar from '../../../Component/Customers/slidebar/CraneSideBar.jsx'


const btns = [
    { name: "Complete Process", id: 1 },
    { name: "Process", id: 2 },
]

const HistoryReceipts = ({ vehicleNumber }) => {
    //console.log("vehilceCode", vehicleNumber)
    const navigate = useNavigate()
    const { state } = useLocation();
    const currentService = localStorage.getItem("currentService");

    const [currentStage, setCurrentStage] = useState([]); // Example stage
    //console.log("currentStage112", currentStage)
    const [isHistoryPage, setIsHistoryPage] = useState(false);
    const [viewReceipts, setViewReceipts] = useState(false);
    const [avg, setAvg] = useState([])
    const [data, setData] = useState([]);
    const [filtering, setFiltering] = useState([]);
    const [notCompleted, setNotCompleted] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [doneFetching, setDoneFetching] = useState(false)

    const [filter, setFilter] = useState('')

    //console.log("DATA HERE", data)
    const [currentItemIndex, setCurrentItemIndex] = useState(null);
    const [dataIndex, setDataIndex] = useState(0);

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    //console.log('isImageContainer', isHistoryPage)

    const getFilteredData = (filter) => {
        //console.log("data is here");
        const filteredData = [];

        const now = new Date();  // Current date and time
        const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
        const yesterday = new Date(now.getTime() - oneDay); // Yesterday's date and time
        const weekBefore = new Date(now.getTime() - (oneDay * 7));
        const monthBefore = new Date(now.getTime() - (oneDay * 30));




        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const todayDate = formatDate(now);
        const yesterdayDate = formatDate(yesterday);
        const weekBeforeDate = formatDate(weekBefore)
        const monthBeforeDate = formatDate(monthBefore)

        //console.log("todayDate", todayDate)
        //console.log("yesterdayDate", yesterdayDate)


        for (let i = 0; i < filtering.length; i++) {

            let getTime = filtering[i]?.[`${currentService}Details`]?.systemDate.split('|');
            let assignedDate = getTime[0];
            let assignedTime = getTime[1];
            let assignedDateTime = new Date(`${assignedDate} ${assignedTime}`);

            if (filter === 'daily') {
                //console.log("here i am daily")
                if (assignedDate === todayDate || assignedDate === yesterdayDate) {
                    const timeDifference = now - assignedDateTime;
                    if (timeDifference <= oneDay) {
                        //console.log("Match found within last 24 hours:", data[i]);
                        filteredData.push(filtering[i]);
                    }
                }
            }
            else if (filter === 'weekly') {
                //console.log("here i am weekly")
                if (assignedDateTime >= weekBefore && assignedDateTime <= now) {
                    //console.log("Match found within last 7 days:", data[i]);
                    filteredData.push(filtering[i]);
                }
            }
            else if (filter === 'monthly') {
                if (assignedDateTime >= monthBefore && assignedDateTime <= now) {
                    //console.log("Match found within last 30 days:", data[i]);
                    filteredData.push(filtering[i]);
                }
            }
            else if (filter === 'year') {
                const yearBefore = new Date(now.getTime() - (oneDay * 365)); // Calculate date one year ago
                if (assignedDateTime >= yearBefore && assignedDateTime <= now) {
                    //console.log("Match found within last year:", filtering[i]);
                    filteredData.push(filtering[i]);
                }
            }

        }
        if (filter === 'newest') {
            //console.log("Sorting by newest to oldest");
            //console.log("filtering", filtering[0])
            filtering.sort((a, b) => {
                //console.log("a?.[`${currentService}Details`]?.systemDate", a?.[`${currentService}Details`]?.systemDate)
                const dateA = new Date(a?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                const dateB = new Date(b?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                return dateB - dateA; // Descending order
            });
            setData([...filtering]);
        } else if (filter === 'oldest') {
            //console.log("Sorting by oldest to newest");
            filtering.sort((a, b) => {
                const dateA = new Date(a?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                const dateB = new Date(b?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                return dateA - dateB; // Ascending order
            });
            setData([...filtering]);
        }
        else {
            setData(filteredData)
        }
    };

    const settingFilter = (filter) => {
        //console.log("filter", filter)
        setFilter(filter)
        getFilteredData(filter)
        setOpenFilterModal(false)
    }



    const goToMap = () => {
        navigate('/SelectLocationOnMap', { state: { center: [28.7041, 77.1025] } })
    }

    useEffect(() => {
        //console.log('hey123323')
        setDoneFetching(false)
        getData();
        getVendorRating()
        //console.log("token", token, userId);
        if (token === "" || userId === "") {
            navigate("/");
        }
    }, [token, userId, navigate, currentService]);


    useEffect(() => {
        if (data.length > 0 && data.length != currentStage.length) {
            data.map((item) => {
                avg.push(0)
            })

        }

    }, [data])

    const getStage = (systemDate, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime) => {
        return [systemDate, customerAcceptedVendorTime, vendorMovedTime, vendorReachedTime, doneWorkingTime]
    }
    const getStageAndHistory = (item, index) => {

        let gotStage = getStage(item?.[`${currentService}Details`]?.systemDate, item?.[`${currentService}Details`]?.customerAcceptedVendorTime, item?.[`${currentService}Details`]?.vendorMovedTime, item?.[`${currentService}Details`]?.vendorReachedTime, item?.[`${currentService}Details`]?.doneWorkingTime)
        console.log('goto stage: ==================');
        console.log(gotStage);
        currentStage.unshift(gotStage)

        console.log('currentStage ');
        console.log(currentStage);
    }

    const [stages, setStages] = useState([]); // Use useState for stages
    //console.log("stages123456789 ================================= ", stages)

    useEffect(() => {
        //console.log("hello currentStage", currentStage);
        if (currentStage[0]) {
            //console.log("helasdfasdflo");
            //console.log("currentStage[0][0] ", currentStage[0])
            setStages([
                { label: "Filed", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/assignedTask.png', date: currentStage[0][0] ? currentStage[0][0].split('T')[0] + ' | ' + currentStage[0][0].split('T')[1].split('.')[0] : '' },
                { label: "Vendor Assigned", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/checksuccess.png', date: currentStage[0][1] ? currentStage[0][1].split('T')[0] + ' | ' + currentStage[0][1].split('T')[1].split('.')[0] : "" },
                { label: "Accepted & Moved", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/comingCrane.png', date: currentStage[0][2] ? currentStage[0][2].split('T')[0] + ' | ' + currentStage[0][2].split('T')[1].split('.')[0] : "" },
                { label: "Reached", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/reachedUser.png', date: currentStage[0][3] ? currentStage[0][3].split('T')[0] + ' | ' + currentStage[0][3].split('T')[1].split('.')[0] : "" },
                { label: "Work Done", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/workDoneUser.png', date: currentStage[0][4] ? currentStage[0][4].split('T')[0] + ' | ' + currentStage[0][4].split('T')[1].split('.')[0] : "" },
            ]);
        }
    }, [currentStage[0]]); // Dependency array

    // useEffect(() => {
    //     //console.log("stages updated:", stages);
    // }, [stages]);

    const getData = async (e) => {
        //console.log("userid", userId);
        // const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getPersonalAccidentVehicleInfoById/${userId}/${currentService}/not_defined`, {
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // });

        const response = await axios.get(`http://localhost:3001/api/getPersonalAccidentVehicleInfoById/CC-ea5ff8d5-9058-476a-8df1-97ddc452f010/recoveryVan/not_defined`, {
            headers: {
                'Authorization': `Bearer 7034134cab4d43ab8f90a1f8059366aa2cf14356eb6b73ca3fccde5731b154e0ae61e4d9a4e20c56ee05dfebfeea0018bb607f602cd7acf6b12fa57a33a5ff47c3431b4a55debd73b47d15752f6ee7c7be65d3db776c67f3e1a73337df96433c2dbdb887dbdff87c00aad935c75d702ba6e41873e96f9deed6ea395c80f15e10262cc0497cad86b5b36f4bbbc57660ca62783a936b69eb90e3c6a3595bde9ff77eccd10e8bca7ef493dc069f08cf79abe33d9b765ca6aa0f9815de0178ec310a2e4bb8d9b6b2d92bca7f953e6b241c97948e5da391038151dbae865f23460fb24ffa2c4dc04280c662cd44bf49bc24ae`
            }
        });

        if (response.data.message === "No accident vehicle data found.") {
            setData([])
            //console.log('hellow not data')
            setDoneFetching(true)
        }
        else {
            //console.log("response123421", response.data.data);
            //console.log("data2", response.data.data2);

            let filteredData = response.data.data.filter((info) =>
                info?.[`${currentService}Details`]?.confirmDoneWorking === 1 &&
                info?.[`${currentService}Details`]?.customerAcceptedVendor === 1 &&
                info?.[`${currentService}Details`]?.cancelOrder === 0 &&
                info?.[`${currentService}Details`]?.cancelPreAssignOrder === 0 &&
                info?.[`${currentService}Details`]?.completeOrder === 1
            );

            let notCompleted = response.data.data.filter((info) =>
                info?.[`${currentService}Details`]?.confirmDoneWorking === 0 &&
                info?.[`${currentService}Details`]?.cancelOrder === 0 &&
                info?.[`${currentService}Details`]?.cancelPreAssignOrder === 0 &&
                info?.[`${currentService}Details`]?.completeOrder === 0
            );

            //console.log('fileteredData', filteredData);
            //console.log('notCompleted', notCompleted);

            setFiltering(filteredData)
            setFilteredData(filteredData);
            setData(filteredData)
            setNotCompleted(notCompleted)
            //console.log('hellow data2')
            setDoneFetching(true)

            console.log(filteredData);

            console.log(stages);
        }
    };

    const getVendorRating = async (crane) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/customersRating/${crane}`);
            //console.log("coming Customer Rating", response.data)
            if (response.data.status === 404) {
                //console.log("Not Found")
                avg.push(0)
            }
            else if (response.data.status === true) {
                let customerRating = response.data.data;
                //console.log("coming Customer Rating", customerRating)
                if (customerRating.length !== 0) {
                    let average = customerRating.reduce((acc, item) => acc + parseInt(item.feedbackRatingCrane), 0);

                    avg.push(average / customerRating.length);
                }
            }
        } catch (error) {
            //console.log("Error from get Vendor Rating", error.message)
        }
    }

    const [searchValue, setSearchValue] = useState('');
    useEffect(() => {
        if (vehicleNumber && filtering.length > 0) {
            setSearchValue(vehicleNumber);
            handleSearch(vehicleNumber);
        }
    }, [vehicleNumber, filtering]);

    useEffect(() => {
        return () => setSearchValue('');
    }, []);
    const handleSearch = (inputValue) => {
        const value = inputValue?.toLowerCase() ?? searchValue.toLowerCase()
        setSearchValue(value);
        //console.log("VALUE123", value)

        const newRows = filtering.filter((row) => {
            const formattedId = String(row.id).padStart(4, '0').toLowerCase();
            const idValue = formattedId.includes(value);
            const vehicleNoValue = (row?.[`${currentService}Details`]?.vehicleNo ?? '').toLowerCase().includes(value);
            const chassisNoValue = (row?.[`${currentService}Details`]?.chassisNo ?? '').toLowerCase().includes(value);
            return idValue || vehicleNoValue || chassisNoValue;
        });
        setData(newRows);
    };

    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleSelect = (index) => {

        setSelectedIndex(index);
        //console.log("SELECTEDINDOEX", index)
        //console.log("filtering", filtering)

        if (index === 0) {
            setFiltering([...filteredData]);
            setData([...filteredData]);
        } else {
            setData([...notCompleted]);
        }
        //console.log("d", notCompleted.length)
        //console.log("notCompleted", data.length)
    };

    const [hBtn, setHBtn] = useState("Complete Process")

    const callButtonClick = (e) => {

        console.log(e);
        setHBtn(e)
        let index = e === 'Complete Process' ? 0 : 1;
        console.log(index);
        handleSelect(index)

    }

    return (

        <>
            {/* <div className='crane-section'>
                <h6 className="font-[700] text-center font-satoshi text-[61px] leading-[68px] text-[#FFFFFF] pt-[52px] mb-0 pb-[72px]">
                    Crane Service</h6>
                <div style={{ backdropFilter: "blur(20px)", height: "79px" }} className="flex bg-[#FFFFFF4D] max-w-[736px] w-full mx-auto py-[28px] rounded-[66px] pl-[40px] mb-[78px] pr-[28px] items-center justify-between">
                    <input type="text" className='outline-none bg-transparent text-[#FFFFFF] placeholder:text-[#FFFFFF] font-[500] text-[16px] leading-[20px]' placeholder='Search By Service' />
                    <img src={search} style={{ height: "23px", width: "23px" }} alt="" />
                </div>

            </div> */}
            <div className='bg-white flex md:flex-row flex-col justify-center gap-[30px]'>
                <CraneSideBar />
                <div className='max-w-[979px] py-[38px] px-[40px] w-full bg-[#EFF9FD] border-[1px] border-[#E7E4FC] rounded-[12px]'>
                    <h6 className="font-[700] font-satoshi text-[30px] text-[#0A0119] m-0 pb-[30px]">History & Receipts</h6>
                    <div className="flex gap-[12px] pb-[26px]">
                        {btns?.map((e) => {
                            return (
                                <>
                                    <button key={e?.id} onClick={() => callButtonClick(e?.name)}
                                        className={`rounded-[92px] font-satoshi text-[16px] border-[1px] py-[14px] max-w-[202px] w-full ${hBtn === e?.name ? "bg-[#21A6E9] text-[#FFFFFF] border-[#E7E4FC] font-[700]" : "bg-[#FFFFFF] text-[#000000] border-[#E7E4FC] font-[400]"}`}>{e?.name}</button>
                                </>
                            )
                        })}
                    </div>
                    {data.length > 0 && (
                        <div className='h-[500px] overflow-y-auto ' style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                            <div style={{ overflow: 'hidden' }}>
                                {hBtn === "Complete Process" &&
                                    <div className="grid md:grid-cols-2 grid-cols-1 gap-[23px] ">

                                        {data.map((item, dataIndex) => (

                                            <div className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] py-[40px] px-[30px] rounded-[12px] ">
                                                <ol className="flex items-start gap-[3px] justify-between his-line max-w-[536px] pl-0 mb-0 mx-auto w-full">
                                                    <li className='h-full w-[38px]' title={item?.[`${currentService}Details`]?.systemDate?.replace('T', ' | ').replace('.000Z', '')} >
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon12.svg' className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Filled</p>
                                                        </div>
                                                    </li>
                                                    <li className='w-[60px]' title={item?.[`${currentService}Details`]?.customerAcceptedVendorTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon13.svg' className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Vendor Assigned</p>
                                                        </div>
                                                    </li>
                                                    <li className='w-[60px]' title={item?.[`${currentService}Details`]?.vendorMovedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon14.svg' className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Accepted & Moved</p>
                                                        </div>
                                                    </li>
                                                    <li className='w-[60px]' title={item?.[`${currentService}Details`]?.vendorReachedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon15.svg' className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Reached</p>
                                                        </div>
                                                    </li>
                                                    <li className='w-[60px]' title={item?.[`${currentService}Details`]?.doneWorkingTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon16.svg' className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Work Done</p>
                                                        </div>
                                                    </li>
                                                </ol>
                                                <div className="flex justify-center">
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon11.svg' className='h-[150px] w-[150px] py-[28px]' alt="" />
                                                </div>
                                                <div className="grid sm:grid-cols-2 gap-[60px] gap-y-[20px]">
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.[`${currentService}Details`]?.vehicleNo}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vehicle No</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.[`${currentService}Details`]?.systemDate?.split("T")[0]}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Registered Date</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{currentService.charAt(0).toUpperCase() + currentService.slice(1).toLowerCase()}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vendor</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">Work Done</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Current Status</p>
                                                    </div>
                                                </div>
                                            </div>

                                        ))}
                                    </div>
                                }
                                {hBtn === "Process" &&
                                    <div className="grid md:grid-cols-2 grid-cols-1 gap-[23px]">

                                        {data.map((item, dataIndex) => (

                                            <div className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] py-[40px] px-[30px] rounded-[12px] ">

                                                <ol className="flex items-start gap-[3px] justify-between his-line max-w-[536px] pl-0 mb-0 mx-auto w-full">
                                                    <li className='h-full w-[38px]' title={item?.[`${currentService}Details`]?.systemDate?.replace('T', ' | ').replace('.000Z', '')} >
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon12.svg' className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Filled</p>
                                                        </div>
                                                    </li>
                                                    <li className='w-[60px]' title={item?.[`${currentService}Details`]?.customerAcceptedVendorTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon13.svg' className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Vendor Assigned</p>
                                                        </div>
                                                    </li>
                                                    <li className='w-[60px]' title={item?.[`${currentService}Details`]?.vendorMovedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon14.svg' className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Accepted & Moved</p>
                                                        </div>
                                                    </li>
                                                    <li className='w-[60px]' title={item?.[`${currentService}Details`]?.vendorReachedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon15.svg' className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Reached</p>
                                                        </div>
                                                    </li>
                                                    <li className='w-[60px]' title={item?.[`${currentService}Details`]?.doneWorkingTime?.replace('T', ' | ').replace('.000Z', '')}>
                                                        <div className="flex flex-col items-center gap-[6px]">
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon16.svg' className='h-[38px] w-[38px]' alt="" />
                                                            <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Work Done</p>
                                                        </div>
                                                    </li>
                                                </ol>

                                                <div className="flex justify-center">
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon11.svg' className='h-[150px] w-[150px] py-[28px]' alt="" />
                                                </div>

                                                <div className="grid sm:grid-cols-2 gap-[60px] gap-y-[20px]">
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.[`${currentService}Details`]?.vehicleNo}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vehicle No</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item?.[`${currentService}Details`]?.systemDate?.split("T")[0]}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Registered Date</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">Crane Work</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vendor</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">Processing</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Current Status</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                }
                            </div>
                        </div>
                    )}

                    {data.length == 0 && (
                        <NoDataFound />
                    )}
                </div>
            </div>
        </>

    )
}

export default HistoryReceipts;